import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';

@Component({
  selector: 'cc-signature-pad',
  templateUrl: 'signature-pad.component.html',
  styleUrls: ['signature-pad.component.scss'],
})
export class CCSignaturePadComponent {
  @ViewChild('signaturePad')
  signaturePad: SignaturePad;

  @Input()
  src;

  @Input()
  height;

  @Input()
  width;

  @Input()
  options;

  @Output()
  end = new EventEmitter();

  @Output()
  start = new EventEmitter();

  onEnd() {
    this.end.emit(this.signaturePad);
  }

  onStart() {
    this.start.emit();
  }
}
